import Vue from 'vue'
import Router from 'vue-router'
import Page from './views/Page.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base:'/',
    routes: [
        {
            path: '/feature/:name/:latest_list/:hot_list',
            name: 'feature',
            component: Page
        },
        {
            path: '/feature/:name/',
            redirect: to=>{
                const {  params } = to
                return {name:'feature',params:{name:params.name,latest_list:1,hot_list:1}}
            }
        },
        {
            path: '/author/:name/:latest_list/:hot_list',
            name: 'author',
            component: Page
        },
        {
            path: '/author/:name/',
            redirect: to=>{
                const {  params } = to
                return {name:'author',params:{name:params.name,latest_list:1,hot_list:1}}
            }
        },
        {
            path: '/hashtag/:name/:latest_list/:hot_list',
            name: 'hashtag',
            component: Page
        },
        {
            path: '/hashtag/:name/',
            redirect: to=>{
                const {  params } = to
                return {name:'hashtag',params:{name:params.name,latest_list:1,hot_list:1}}
            }
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})


export default router;